// QR Code modal - generate and download QR codes for links
import React, { useRef, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { FiX, FiDownload } from "react-icons/fi";
import "../styles/Modal.css";

export default function QRCodeModal({ link, onClose }) {
  const canvasRef = useRef();

  // Lock body scroll while modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  const downloadQR = () => {
    const canvas = canvasRef.current?.querySelector("canvas");
    if (!canvas) return;
    const url = canvas.toDataURL("image/png");
    const a = document.createElement("a");
    a.href = url;
    a.download = `${link.short_code}-qr.png`;
    a.click();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content qr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>QR Code</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>
        <div className="qr-body">
          <div className="qr-canvas-wrapper" ref={canvasRef}>
            <QRCodeCanvas
              value={link.short_url}
              size={200}
              level="H"
              marginSize={2}
              bgColor="#ffffff"
              fgColor="#37352f"
            />
          </div>
          <div className="qr-link-label">{link.short_url}</div>
          <p className="qr-title">{link.title || link.short_code}</p>
          <button className="btn-primary qr-download-btn" onClick={downloadQR}>
            <FiDownload size={14} /> Download PNG
          </button>
        </div>
      </div>
    </div>
  );
}
